// Fix: cart drawer overlay click not closing when cart is emptied after item removal.
// refreshCartDrawer() replaces #CartDrawer's innerHTML, which destroys the overlay element
// and its direct click listener. Event delegation from document handles the new overlay too.
document.addEventListener('click', function (e) {
  if (e.target && e.target.id === 'CartDrawer-Overlay') {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    }
  }
});

// Continue shopping link redirect to collections/all
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const continueShoppingLinks = document.querySelectorAll('.c-continue-shopping-link');
    continueShoppingLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const collectionsUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'collections/all') || '/collections/all';
        window.location.href = collectionsUrl;
      });
    });

    const drawer = document.querySelector("#Details-menu-drawer-container");
    const bar = document.querySelector(".announcement-bar-section");

    if (drawer && bar) {
      drawer.addEventListener("toggle", () => {
        if (drawer.open) {
          bar.style.zIndex = "1";
        } else {
          bar.style.zIndex = "";
        }
      });
    }

    // My Designs count badge – same logic as canvas-preview-grid-2 (only count valid/displayed items)
    var secretKey = "p?c7=pAc0v6F";
    function decryptImageUrl(encodedText) {
      try {
        var decoded = atob(encodedText);
        var result = "";
        for (var i = 0; i < decoded.length; i++) {
          result += String.fromCharCode(
            decoded.charCodeAt(i) ^ secretKey.charCodeAt(i % secretKey.length)
          );
        }
        return result;
      } catch (e) {
        return "";
      }
    }
    function isImageUrlValid(url) {
      try {
        if (!url) return false;
        var urlObj = new URL(url);
        var expires = urlObj.searchParams.get("Expires");
        if (!expires) return false;
        var expiresTime = parseInt(expires, 10) * 1000;
        return Date.now() < expiresTime;
      } catch (e) {
        return false;
      }
    }
    function getMyDesignsCount() {
      try {
        var raw = localStorage.getItem("userCanvas");
        if (!raw) return 0;
        var data = JSON.parse(raw);
        var uid = localStorage.getItem("uniqueUserId");
        if (!uid) return 0;
        var user = data.find(function (entry) { return entry.uniqueUserId === uid; });
        var list = (user && user.processdImages) ? user.processdImages : [];
        var count = 0;
        for (var i = 0; i < list.length; i++) {
          var decrypted = decryptImageUrl(list[i].imageUrl);
          if (isImageUrlValid(decrypted)) count++;
        }
        return count;
      } catch (e) {
        return 0;
      }
    }

    function updateMyDesignsBadges() {
      const count = getMyDesignsCount();
      const links = document.querySelectorAll('a[href*="my-designs"]');
      links.forEach(function (link) {
        if (link.textContent.trim() !== "My Designs") return;
        var badge = link.querySelector(".c-my-designs-count");
        if (count > 0) {
          if (!badge) {
            badge = document.createElement("span");
            badge.setAttribute("aria-hidden", "true");
            badge.className = "c-my-designs-count";
            link.appendChild(badge);
          }
          badge.textContent = count > 99 ? "99+" : String(count);
        } else {
          if (badge) badge.remove();
        }
      });
    }

    updateMyDesignsBadges();

    // Loox review card overlay: force bottom-center + style Loox-injected elements (Var A only)
    function cPositionLooxCardOverlays() {
      if (!document.body.classList.contains("c-loox-review-card-varA")) return;
      var overlays = document.querySelectorAll(".card__media > .c-loox-card-overlay");
      overlays.forEach(function (overlay) {
        overlay.style.visibility = "hidden";
        var cardMedia = overlay.parentElement;
        var media = cardMedia.querySelector(":scope > .media");
        if (!media) return;
        cardMedia.style.position = "absolute";
        cardMedia.style.overflow = "visible";
        overlay.style.position = "absolute";
        var isMobile = window.matchMedia("(max-width: 749px)").matches;
        overlay.style.bottom = isMobile ? "6px" : "12px";
        overlay.style.left = "50%";
        overlay.style.transform = "translateX(-50%)";
        overlay.style.top = "auto";
        overlay.style.right = "auto";
        overlay.style.zIndex = "10";
        overlay.style.background = "#fff";
        var rowHeight = isMobile ? "19px" : "24px";
        overlay.style.height = rowHeight;
        overlay.style.width = isMobile ? "137px" : "175px";
        overlay.style.borderRadius = "2px";
        var looxRating = overlay.querySelector(".loox-rating");
        if (looxRating) {
          looxRating.style.height = rowHeight;
          looxRating.style.display = "flex";
          looxRating.style.alignItems = "center";
          looxRating.style.justifyContent = "center";
        }
        var looxRatingContent = overlay.querySelector(".loox-rating-content");
        if (looxRatingContent) looxRatingContent.style.height = rowHeight;
        var looxLabel = overlay.querySelector(".loox-rating-label");
        if (looxLabel) {
          looxLabel.style.fontSize = isMobile ? "12px" : "14px";
          looxLabel.style.fontFamily = "Karla, sans-serif";
          looxLabel.style.fontWeight = "700";
          looxLabel.style.marginLeft = "5px";
          var count = (looxRating && looxRating.getAttribute("data-raters")) || "";
          var num = parseInt(count, 10);
          if (isNaN(num)) {
            var match = (looxLabel.textContent || "").match(/\((\d+)\)/);
            if (match) num = parseInt(match[1], 10);
          }
          if (!isNaN(num)) looxLabel.textContent = num === 1 ? "1 review" : num + " reviews";
        }
        var iconSize = isMobile ? "9px" : "14px";
        var looxIcons = overlay.querySelectorAll(".loox-icon");
        looxIcons.forEach(function (icon) {
          icon.style.width = iconSize;
          icon.style.height = iconSize;
          icon.style.color = "#FFCC02";
        });
        overlay.style.visibility = "visible";
      });
    }
    cPositionLooxCardOverlays();
    window.addEventListener("load", cPositionLooxCardOverlays);
    window.addEventListener("resize", cPositionLooxCardOverlays);
    setTimeout(cPositionLooxCardOverlays, 500);
    setTimeout(cPositionLooxCardOverlays, 1500);
  });
})();

// PDP Inline Upload + Generation Flow
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.c-pdp-upload');
    if (!container) return;

    var API_URL = 'https://exeapiv2.wonderme.co/';
    var PROCESS_IMG_ENDPOINT = 'process_image/';
    var TASK_STATUS_ENDPOINT = 'task_status/';

    var productHandle = container.dataset.productHandle;
    var gender = container.dataset.gender || null;
    var taggerPrompt = container.dataset.taggerPrompt || null;
    var category = container.dataset.category || null;
    var templateName = container.dataset.templateName || null;

    var stepUpload = container.querySelector('[data-step="upload"]');
    var stepPreview = container.querySelector('[data-step="preview"]');
    var stepGenerating = container.querySelector('[data-step="generating"]');
    var stepResult = container.querySelector('[data-step="result"]');

    var imageInput = document.getElementById('c-pdp-image-input');
    var imageInputReplace = document.getElementById('c-pdp-image-input-replace');
    var thumbPreview = document.getElementById('c-pdp-thumb');
    var thumbGen = document.getElementById('c-pdp-thumb-gen');
    var thumbResult = document.getElementById('c-pdp-thumb-result');
    var ageInput = document.getElementById('c-pdp-age-input');
    var createBtn = document.getElementById('c-pdp-create-btn');
    var atcBtn = document.getElementById('c-pdp-atc-btn');
    var progressFill = document.getElementById('c-pdp-progress-fill');
    var progressText = document.getElementById('c-pdp-progress-text');
    var generatedImg = document.getElementById('c-pdp-generated-img');
    var tryDifferentBtn = document.getElementById('c-pdp-try-different');
    var zoomBtn = document.getElementById('c-pdp-zoom-btn');

    var generationProgress = document.getElementById('c-pdp-generation-progress');
    var resultContent = document.getElementById('c-pdp-result-content');
    var safeText = document.querySelector('.c-pdp-upload__safe-text');

    var uploadedBase64 = null;
    var selectedVariantId = null;
    var selectedImageURL = '';
    var genTimers = [];
    var currentCurrency = window.cartCurrency || '';
    var isAddingToCart = false;

    var generationLabelText = document.getElementById('c-pdp-generation-label-text');
    var generationLabels = [
      { max: 12,  text: 'Unleashing creativity...' },
      { max: 24,  text: 'Crafting your masterpiece...' },
      { max: 37,  text: 'Adding a touch of magic...' },
      { max: 49, text: 'Almost there...' },
      { max: 62,  text: 'Generating artwork...' },
      { max: 74,  text: 'Adding magical details...' },
      { max: 87,  text: 'Creating your portrait...' },
      { max: 100,  text: 'Summoning pixels...' }
    ];

    function updateProgress(p) {
      var val = Math.max(0, Math.min(Math.floor(p), 100));
      progressFill.style.width = val + '%';
      progressText.textContent = val + '%';
      progressText.style.left = val + '%';
      if (generationLabelText) {
        for (var i = 0; i < generationLabels.length; i++) {
          if (val <= generationLabels[i].max) {
            generationLabelText.textContent = generationLabels[i].text;
            break;
          }
        }
      }
    }

    function showStep(step) {
      [stepUpload, stepPreview, stepGenerating, stepResult].forEach(function (el) {
        el.style.display = 'none';
      });
      step.style.display = '';
    }

    // Button is always enabled; validation happens on click instead.
    function updateButtonStates() {
      if (createBtn) createBtn.disabled = false;
    }

    // Inline error message helper for the Create button
    // Popup/toast error message for the Create button
    // Popup/toast error message positioned above the Create button
    function showCreateBtnError(message) {
      var popup = document.getElementById('c-pdp-error-popup');
      if (!popup) {
        popup = document.createElement('div');
        popup.id = 'c-pdp-error-popup';
        popup.style.cssText = [
          'position:fixed',
          'background:#fff',
          'color:#d32f2f',
          'border:1.5px solid #d32f2f',
          'border-radius:10px',
          'padding:10px 16px',
          'font-size:14px',
          'font-weight:600',
          'box-shadow:0 6px 24px rgba(0,0,0,0.18)',
          'z-index:99999',
          'opacity:0',
          'pointer-events:none',
          'transition:opacity 0.25s ease, transform 0.25s ease',
          'display:inline-flex',
          'align-items:center',
          'gap:10px',
          'line-height:1.2',
          'width:max-content',
          'max-width:calc(100vw - 24px)',
          'white-space:nowrap'
        ].join(';');

        var icon = document.createElement('span');
        icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#d32f2f"><path d="M12 2L1 21h22L12 2zm0 6l7.53 13H4.47L12 8zm-1 4v4h2v-4h-2zm0 5v2h2v-2h-2z"/></svg>';
        icon.style.cssText = 'flex:0 0 auto;display:inline-flex;align-items:center;';

        var textEl = document.createElement('span');
        textEl.id = 'c-pdp-error-popup-text';

        popup.appendChild(icon);
        popup.appendChild(textEl);
        document.body.appendChild(popup);
      }

      var textEl = document.getElementById('c-pdp-error-popup-text');
      if (textEl) textEl.textContent = message;

      // Decide which button is currently visible to anchor against
      var anchorBtn = null;
      var createBtnEl = document.getElementById('c-pdp-create-btn');
      var atcBtnEl = document.getElementById('c-pdp-atc-btn');
      if (atcBtnEl && atcBtnEl.style.display !== 'none' && atcBtnEl.offsetParent !== null) {
        anchorBtn = atcBtnEl;
      } else if (createBtnEl && createBtnEl.offsetParent !== null) {
        anchorBtn = createBtnEl;
      }

      // Reset for measurement
      popup.style.whiteSpace = 'nowrap';
      popup.style.width = 'max-content';
      popup.style.opacity = '0';

      var naturalWidth = popup.offsetWidth;
      var maxAllowed = window.innerWidth - 24;
      if (naturalWidth > maxAllowed) {
        popup.style.whiteSpace = 'normal';
        popup.style.width = maxAllowed + 'px';
      }

      // Position above the button
      if (anchorBtn) {
        var rect = anchorBtn.getBoundingClientRect();
        var popupWidth = popup.offsetWidth;
        var popupHeight = popup.offsetHeight;

        // Center horizontally over the button
        var btnCenterX = rect.left + rect.width / 2;
        var left = btnCenterX - popupWidth / 2;
        // Clamp inside viewport
        if (left < 12) left = 12;
        if (left + popupWidth > window.innerWidth - 12) {
          left = window.innerWidth - popupWidth - 12;
        }

        var top = rect.top - popupHeight - 12;
        // If there's not enough space above, show below
        if (top < 8) {
          top = rect.bottom + 12;
        }

        popup.style.left = left + 'px';
        popup.style.top = top + 'px';
        popup.style.transform = 'translateY(-8px)';
      } else {
        // Fallback — top of viewport
        popup.style.left = '50%';
        popup.style.top = '20px';
        popup.style.transform = 'translate(-50%, -8px)';
      }

      requestAnimationFrame(function () {
        popup.style.opacity = '1';
        popup.style.transform = anchorBtn ? 'translateY(0)' : 'translate(-50%, 0)';
      });

      clearTimeout(showCreateBtnError._t);
      showCreateBtnError._t = setTimeout(function () {
        if (popup) {
          popup.style.opacity = '0';
          popup.style.transform = anchorBtn ? 'translateY(-8px)' : 'translate(-50%, -8px)';
        }
      }, 3500);
    }

    function hideCreateBtnError() {
      var popup = document.getElementById('c-pdp-error-popup');
      if (popup) popup.style.opacity = '0';
    }

    function clearGenTimers() {
      genTimers.forEach(function (id) { clearInterval(id); clearTimeout(id); });
      genTimers = [];
    }

    function compressImage(src, maxSize, quality) {
      maxSize = maxSize || 2000;
      quality = quality || 0.7;
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          var w = img.width, h = img.height;
          if (w > maxSize || h > maxSize) {
            if (w > h) { h = Math.round((h * maxSize) / w); w = maxSize; }
            else { w = Math.round((w * maxSize) / h); h = maxSize; }
          }
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          c.getContext('2d').drawImage(img, 0, 0, w, h);
          resolve(c.toDataURL('image/jpeg', quality));
        };
        img.onerror = reject;
        img.src = src;
      });
    }

    function base64ToBlob(b64) {
      var parts = b64.split(',');
      var bytes = atob(parts[1]);
      var arr = [];
      for (var i = 0; i < bytes.length; i++) arr.push(bytes.charCodeAt(i));
      return new Blob([new Uint8Array(arr)], { type: 'image/jpeg' });
    }

    var personalizeSection = document.getElementById('c-pdp-personalize');

    function handleImageUpload(file) {
      if (!file || !file.type.startsWith('image')) return;

      // Reset any previously generated state
      selectedImageURL = '';
      clearGenTimers();
      if (generationProgress) generationProgress.style.display = 'none';
      if (resultContent) resultContent.style.display = 'none';
      atcBtn.style.display = 'none';
      atcBtn.disabled = true;
      hideCreateBtnError();

      var reader = new FileReader();
      reader.onload = function (e) {
        compressImage(e.target.result).then(function (compressed) {
          uploadedBase64 = compressed;
          try { localStorage.setItem('uploadedImage', compressed); } catch (e) { /* noop */ }
          [thumbPreview, thumbGen, thumbResult].forEach(function (el) {
            if (el) el.src = compressed;
          });
          showStep(stepPreview);
          if (personalizeSection) personalizeSection.style.display = '';
          if (safeText) safeText.style.display = '';
          createBtn.style.display = '';
          updateButtonStates();
        });
      };
      reader.readAsDataURL(file);
    }

    if (imageInput) {
      imageInput.addEventListener('change', function (e) {
        handleImageUpload(e.target.files[0]);
        imageInput.value = '';
      });
    }

    if (imageInputReplace) {
      imageInputReplace.addEventListener('change', function (e) {
        handleImageUpload(e.target.files[0]);
        imageInputReplace.value = '';
      });
    }

    if (ageInput) {
      ageInput.addEventListener('input', function () {
        updateButtonStates();
        hideCreateBtnError();
      });
    }

    if (createBtn) {
      createBtn.addEventListener('click', function () {
        var hasPhoto = !!uploadedBase64;
        var hasAge = ageInput && ageInput.value && parseInt(ageInput.value, 10) > 0;

        if (!hasPhoto && !hasAge) {
          showCreateBtnError('Please upload a photo and enter child\'s age');
          return;
        }
        if (!hasPhoto) {
          showCreateBtnError('Please upload a photo first');
          return;
        }
        if (!hasAge) {
          showCreateBtnError('Please enter child\'s age');
          return;
        }

        hideCreateBtnError();
        startGeneration();
      });
    }

    function startGeneration() {
      clearGenTimers();
      showStep(stepGenerating);
      if (generationProgress) generationProgress.style.display = '';
      if (personalizeSection) personalizeSection.style.display = 'none';
      if (safeText) safeText.style.display = 'none';
      createBtn.style.display = 'none';
      atcBtn.style.display = 'none';

      var progress = 0;
      updateProgress(0);
      compressImage(uploadedBase64, 2000, 0.7).then(function (compressed) {
        var blob = base64ToBlob(compressed);
        var file = new File([blob], 'edited-image.jpg', { type: 'image/jpeg' });

        var uniqueUserId = localStorage.getItem('uniqueUserId');
        if (!uniqueUserId) {
          uniqueUserId = Math.floor(Math.random() * 1000000).toString();
          localStorage.setItem('uniqueUserId', uniqueUserId);
        }
        var uploadedCount = parseInt(localStorage.getItem('uploadedCount') || '0', 10) + 1;
        localStorage.setItem('uploadedCount', uploadedCount);
        var userId = uniqueUserId + '_' + uploadedCount;

        var age = ageInput ? ageInput.value : '';
        var formData = new FormData();
        formData.append('user_id', userId);
        formData.append('gender', gender);
        formData.append('age', age);
        formData.append('category', category);
        formData.append('template_name', templateName);
        formData.append('prompt', taggerPrompt);
        formData.append('user_image', file);

        var isCompleted = false;
        var pollingFailed = false;

        fetch(API_URL + PROCESS_IMG_ENDPOINT, { method: 'POST', body: formData })
          .then(function (r) { return r.json(); })
          .then(function () {
            var progressInterval = setInterval(function () {
              if (progress < 60) progress += 1;
              progress = Math.min(progress, 60);
              updateProgress(progress);
              if (progress >= 60) {
                clearInterval(progressInterval);
                pollStatus();
              }
            }, 225);
            genTimers.push(progressInterval);

            var pollingDelay = 1000;

            function pollStatus() {
              if (isCompleted || pollingFailed) return;
              fetch(API_URL + TASK_STATUS_ENDPOINT + userId)
                .then(function (r) { return r.json(); })
                .then(function (data) {
                  if (progress < 100) {
                    var pollingInterval = setInterval(function () {
                      progress += 1;
                      progress = Math.min(progress, 100);
                      updateProgress(progress);
                    }, 720);
                    genTimers.push(pollingInterval);
                    pollingDelay = Math.min(pollingDelay * 1.5, 5000);
                    var t = setTimeout(pollStatus, pollingDelay);
                    genTimers.push(t);
                  } else if (progress >= 100 && data.status === 'processing') {
                    var t2 = setTimeout(pollStatus, pollingDelay);
                    genTimers.push(t2);
                  } else if (data.status === 'success') {
                    isCompleted = true;
                    clearGenTimers();
                    progress = 100;
                    updateProgress(100);
                    onGenerationComplete(data.message);
                  } else if (data.status === 'failed') {
                    pollingFailed = true;
                    clearGenTimers();
                    onGenerationError();
                  }
                })
                .catch(function () {
                  pollingFailed = true;
                  clearGenTimers();
                  onGenerationError();
                });
            }
          })
          .catch(function () {
            onGenerationError();
          });
      });
    }

    function onGenerationComplete(imageUrl, skipSave) {
      if (!imageUrl) {
        onGenerationError();
        return;
      }
      selectedImageURL = imageUrl;
      generatedImg.src = selectedImageURL;

      if (generationProgress) generationProgress.style.display = 'none';
      if (resultContent) resultContent.style.display = '';
      if (personalizeSection) personalizeSection.style.display = 'none';
      if (safeText) safeText.style.display = 'none';
      showStep(stepResult);
      createBtn.style.display = 'none';
      atcBtn.style.display = 'none';
      atcBtn.disabled = !selectedVariantId;

      if (skipSave) return;

      var secretKey = 'p?c7=pAc0v6F';
      function encrypt(text) {
        var result = '';
        for (var i = 0; i < text.length; i++) {
          result += String.fromCharCode(text.charCodeAt(i) ^ secretKey.charCodeAt(i % secretKey.length));
        }
        return btoa(result);
      }

      try {
        var uniqueUserId = localStorage.getItem('uniqueUserId');
        var age = ageInput ? ageInput.value : '';
        var encUrl = encrypt(selectedImageURL);
        var newEntry = {
          productId: null,
          productTitle: document.title,
          productDescription: '',
          productMinPrice: null,
          productMaxPrice: null,
          productUrl: window.location.href,
          imageUrl: encUrl,
          userAge: age
        };
        var existing = JSON.parse(localStorage.getItem('userCanvas') || '[]');
        if (!Array.isArray(existing)) existing = [];
        var userEntry = existing.find(function (e) { return e.uniqueUserId === uniqueUserId; });
        if (userEntry) {
          userEntry.processdImages.push(newEntry);
        } else {
          existing.push({ uniqueUserId: uniqueUserId, processdImages: [newEntry] });
        }
        localStorage.setItem('userCanvas', JSON.stringify(existing));
      } catch (e) { /* noop */ }
    }

    function onGenerationError() {
      if (generationProgress) generationProgress.style.display = 'none';
      if (resultContent) resultContent.style.display = 'none';
      if (personalizeSection) personalizeSection.style.display = '';
      if (safeText) safeText.style.display = '';
      showStep(stepPreview);
      createBtn.style.display = '';
      atcBtn.style.display = 'none';
      updateButtonStates();
      alert('Error generating image. Please try again.');
    }

    if (tryDifferentBtn) {
      tryDifferentBtn.addEventListener('click', function () {
        selectedImageURL = '';
        uploadedBase64 = null;
        if (generationProgress) generationProgress.style.display = 'none';
        if (resultContent) resultContent.style.display = 'none';
        if (personalizeSection) personalizeSection.style.display = '';
        if (safeText) safeText.style.display = '';
        showStep(stepUpload);
        createBtn.style.display = '';
        atcBtn.style.display = 'none';
        atcBtn.disabled = true;
        hideCreateBtnError();
        updateButtonStates();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    var previewBtn = document.getElementById('c-pdp-preview-btn');
if (previewBtn && zoomBtn) {
  previewBtn.addEventListener('click', function () {
    zoomBtn.click();
  });
}

    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        if (!selectedImageURL) return;
        var overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:99999;display:flex;align-items:center;justify-content:center;cursor:pointer;';

        var imgWrapper = document.createElement('div');
        imgWrapper.style.cssText = 'position:relative;max-width:90%;max-height:90%;border-radius:12px;overflow:hidden;';

        var img = document.createElement('img');
        img.src = selectedImageURL;
        img.style.cssText = 'display:block;width:100%;max-width:100%;max-height:90vh;border-radius:12px;';

        var watermark = document.createElement('div');
        watermark.className = 'c-pdp-upload__watermark-overlay';
        watermark.innerHTML = '<div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div>';

        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'c-pdp-upload__zoom-close';
        closeBtn.setAttribute('aria-label', 'Close zoomed image');
        closeBtn.innerHTML = '&times;';
        closeBtn.style.position = 'absolute';
        closeBtn.style.top = '12px';
        closeBtn.style.right = '12px';
        closeBtn.style.width = '32px';
        closeBtn.style.height = '32px';
        closeBtn.style.borderRadius = '50%';
        closeBtn.style.border = 'none';
        closeBtn.style.background = '#000000';
        closeBtn.style.color = '#ffffff';
        closeBtn.style.fontSize = '22px';
        closeBtn.style.fontWeight = '700';
        closeBtn.style.display = 'flex';
        closeBtn.style.alignItems = 'center';
        closeBtn.style.justifyContent = 'center';
        closeBtn.style.cursor = 'pointer';
        closeBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          overlay.remove();
        });

        imgWrapper.appendChild(img);
        imgWrapper.appendChild(watermark);
        imgWrapper.appendChild(closeBtn);
        overlay.appendChild(imgWrapper);
        overlay.addEventListener('click', function () { overlay.remove(); });
        document.body.appendChild(overlay);
      });
    }

    function watchVariantId() {
      var sectionId = container.dataset.sectionId;
      var productInfo = document.getElementById('ProductInfo-' + sectionId);
      if (!productInfo) return;

      var hiddenInput = productInfo.querySelector('input[name="id"]');
      if (hiddenInput) {
        selectedVariantId = hiddenInput.value;
        new MutationObserver(function () {
          selectedVariantId = hiddenInput.value;
          if (atcBtn.style.display !== 'none' && selectedImageURL) {
            atcBtn.disabled = false;
          }
        }).observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
      }

      var qbBtns = productInfo.querySelectorAll('.quantity-break');
      qbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setTimeout(function () {
            var input = productInfo.querySelector('input[name="id"]');
            if (input) selectedVariantId = input.value;
            if (atcBtn.style.display !== 'none' && selectedImageURL) {
              atcBtn.disabled = false;
            }
          }, 50);
        });
      });
    }

    watchVariantId();
    if (personalizeSection) personalizeSection.style.display = '';
    if (productHandle) {
      fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          // Only use as fallback when the hidden input didn't provide a variant ID.
          // Pick the first AVAILABLE variant — never the first variant blindly,
          // because it may be OOS and cause a 422 on cart/add.js.
          if (!selectedVariantId && data.variants && data.variants.length > 0) {
            var firstAvailable = data.variants.find(function (v) { return v.available; });
            selectedVariantId = firstAvailable ? firstAvailable.id : data.variants[0].id;
          }
        });
    }

    // Auto-restore previously uploaded photo from localStorage
    (function () {
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('image')) return; // Coming from My Designs — skip, handled below
      var stored = localStorage.getItem('editedImage') || localStorage.getItem('uploadedImage');
      if (!stored) return;
      uploadedBase64 = stored;
      [thumbPreview, thumbGen, thumbResult].forEach(function (el) {
        if (el) el.src = stored;
      });
      showStep(stepPreview);
      if (personalizeSection) personalizeSection.style.display = '';
      if (safeText) safeText.style.display = '';
      createBtn.style.display = '';
      updateButtonStates();
    })();

    // Pre-load generated image from My Designs page
    (function () {
      var urlParams = new URLSearchParams(window.location.search);
      var preloadImageUrl = urlParams.get('image');
      if (!preloadImageUrl) return;

      var img = new Image();
      img.onload = function () {
        onGenerationComplete(preloadImageUrl, true);
        // Use the stored original uploaded photo for thumbs, not the generated image
        var storedPhoto = localStorage.getItem('editedImage') || localStorage.getItem('uploadedImage');
        var thumbSrc = storedPhoto || preloadImageUrl;
        uploadedBase64 = storedPhoto || null;
        [thumbPreview, thumbGen, thumbResult].forEach(function (el) {
          if (el) el.src = thumbSrc;
        });
      };
      img.src = preloadImageUrl;
    })();

    // ATC handler
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!selectedVariantId || !selectedImageURL) return;
        isAddingToCart = true;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';

        var props = selectedImageURL ? { _selected_image: selectedImageURL } : {};

        var items = [{
          id: selectedVariantId,
          quantity: 1,
          properties: props
        }];

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            localStorage.setItem('cartUpdated', 'true');
            var path = window.location.pathname;
            var match = path.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i);
            var prefix = match ? match[0] : '';
            window.location.href = prefix + '/';
          })
          .catch(function () {
            isAddingToCart = false;
            atcBtn.disabled = false;
            atcBtn.textContent = 'ADD TO CART';
            alert('Error adding to cart. Please try again.');
          });
      });
    }

    // Inline ATC button (placed below price section)
    var inlineAtcBtn = document.getElementById('c-pdp-inline-atc');
    if (inlineAtcBtn && atcBtn) {
      function syncInlineAtc() {
        if (isAddingToCart) return;
        var imageReady = !!selectedImageURL && !atcBtn.disabled;
        if (imageReady) {
          inlineAtcBtn.textContent = 'ADD TO CART';
          inlineAtcBtn.dataset.ready = 'true';
        } else {
          inlineAtcBtn.textContent = 'ADD TO CART';
          inlineAtcBtn.dataset.ready = '';
        }
      }

      inlineAtcBtn.addEventListener('click', function () {
        if (inlineAtcBtn.dataset.ready === 'true') {
          atcBtn.click();
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });

      new MutationObserver(syncInlineAtc).observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });
      syncInlineAtc();
    }
  });
})();

// Collection Card - Upload Image Modal (Var B)
(function () {
  var API_URL = 'https://exeapiv2.wonderme.co/';
  var PROCESS_IMG_ENDPOINT = 'process_image/';
  var TASK_STATUS_ENDPOINT = 'task_status/';

  var modal, closeBtn;
  var stepUpload, stepPreview, stepGenerating, stepResult;
  var imageInput, imageInputReplace, thumbPreview, thumbGen, thumbResult;
  var ageInput, createBtn, atcBtn, progressFill, progressText, generatedImg;
  var generationProgress, resultContent, personalizeSection, variantList;

  var uploadedBase64 = null;
  var selectedVariantId = null;
  var selectedImageURL = '';
  var genTimers = [];
  var isAddingToCart = false;
  var cachedVariants = null;
  var productHandle = null;
  var productId = null;
  var gender = null, taggerPrompt = null, category = null, templateName = null;

  var generationLabels = [
    { max: 12, text: 'Unleashing creativity...' },
    { max: 24, text: 'Crafting your masterpiece...' },
    { max: 37, text: 'Adding a touch of magic...' },
    { max: 49, text: 'Almost there...' },
    { max: 62, text: 'Generating artwork...' },
    { max: 74, text: 'Adding magical details...' },
    { max: 87, text: 'Creating your portrait...' },
    { max: 100, text: 'Summoning pixels...' }
  ];

  function buildModal() {
    var checkSvgWhite = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none"><path d="M16.5542 0.3625C16.0708 -0.120833 15.3458 -0.120833 14.8625 0.3625L5.8 9.425L2.05417 5.67917C1.57083 5.19583 0.845833 5.19583 0.3625 5.67917C-0.120833 6.1625 -0.120833 6.8875 0.3625 7.37083L4.95417 11.9625C5.19583 12.2042 5.4375 12.325 5.8 12.325C6.1625 12.325 6.40417 12.2042 6.64583 11.9625L16.5542 2.05417C17.0375 1.57083 17.0375 0.845833 16.5542 0.3625Z" fill="white"/></svg>';
    var checkSvgGreen = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none"><path d="M16.5542 0.3625C16.0708 -0.120833 15.3458 -0.120833 14.8625 0.3625L5.8 9.425L2.05417 5.67917C1.57083 5.19583 0.845833 5.19583 0.3625 5.67917C-0.120833 6.1625 -0.120833 6.8875 0.3625 7.37083L4.95417 11.9625C5.19583 12.2042 5.4375 12.325 5.8 12.325C6.1625 12.325 6.40417 12.2042 6.64583 11.9625L16.5542 2.05417C17.0375 1.57083 17.0375 0.845833 16.5542 0.3625Z" fill="#39B54A"/></svg>';
    var changePhotoIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><rect x="0.600012" y="0.603125" width="28.2" height="28.2" rx="14.1" fill="#0B1F43"/><rect x="0.600012" y="0.603125" width="28.2" height="28.2" rx="14.1" stroke="#EBBF20" stroke-width="1.2"/><g clip-path="url(#c-change-photo-clip)"><path d="M19.6296 7.77836H17.6375L18.1283 7.28757C18.2979 7.11796 18.2979 6.8437 18.1283 6.67408C17.9587 6.50447 17.6845 6.50447 17.5148 6.67408L16.2879 7.90467C16.2049 7.98767 16.1616 8.09594 16.1616 8.21142C16.1616 8.3269 16.2085 8.43516 16.2879 8.51816L17.5185 9.74875C17.6015 9.83175 17.7133 9.87505 17.8252 9.87505C17.9371 9.87505 18.0453 9.83175 18.1319 9.74875C18.3016 9.57914 18.3016 9.30487 18.1319 9.13526L17.6412 8.64447H19.6332C20.9287 8.64447 21.9789 9.69823 21.9789 10.9902V12.4445C21.9789 12.6827 22.1738 12.8775 22.4119 12.8775C22.6501 12.8775 22.845 12.6827 22.845 12.4445V10.9902C22.845 9.21826 21.4015 7.77836 19.6296 7.77836Z" fill="white"/><path d="M22.3795 14.8828H15.2666C15.0284 14.8828 14.8336 15.0777 14.8336 15.3159V22.4287C14.8336 22.6669 15.0284 22.8618 15.2666 22.8618H22.3795C22.6177 22.8618 22.8125 22.6669 22.8125 22.4287V15.3159C22.8125 15.0741 22.6177 14.8828 22.3795 14.8828ZM21.9464 21.9957H15.6997V15.7489H21.9464V21.9957Z" fill="white"/><path d="M11.8816 19.66C11.712 19.4904 11.4377 19.4904 11.2681 19.66C11.0985 19.8297 11.0985 20.1039 11.2681 20.2735L11.7589 20.7643H9.76685C8.47131 20.7643 7.42116 19.7106 7.42116 18.4186V16.9643C7.42116 16.7261 7.22628 16.5312 6.98811 16.5312C6.74993 16.5312 6.55505 16.7261 6.55505 16.9643V18.4186C6.55505 20.1905 7.99495 21.6304 9.76685 21.6304H11.7589L11.2681 22.1212C11.0985 22.2908 11.0985 22.5651 11.2681 22.7347C11.3511 22.8177 11.463 22.861 11.5748 22.861C11.6867 22.861 11.795 22.8177 11.8816 22.7347L13.1122 21.5041C13.2818 21.3345 13.2818 21.0602 13.1122 20.8906L11.8816 19.66Z" fill="white"/><path d="M7.02058 7.41298C7.13606 7.41298 7.24793 7.36606 7.32732 7.28667C7.40671 7.20728 7.45363 7.09541 7.45363 6.97993C7.45363 6.86805 7.40671 6.75257 7.32732 6.67318C7.24793 6.59379 7.13606 6.54688 7.02058 6.54688C6.9051 6.54688 6.79322 6.59379 6.71383 6.67318C6.63444 6.75257 6.58752 6.86445 6.58752 6.97993C6.58752 7.09541 6.63444 7.20728 6.71383 7.28667C6.79683 7.36606 6.9051 7.41298 7.02058 7.41298Z" fill="white"/><path d="M10.5788 7.41298C10.817 7.41298 11.0119 7.2181 11.0119 6.97993C11.0119 6.74175 10.817 6.54688 10.5788 6.54688C10.3406 6.54688 10.1458 6.74175 10.1458 6.97993C10.1458 7.2181 10.337 7.41298 10.5788 7.41298Z" fill="white"/><path d="M8.79969 7.41298C9.03787 7.41298 9.23274 7.2181 9.23274 6.97993C9.23274 6.74175 9.03787 6.54688 8.79969 6.54688C8.56151 6.54688 8.36664 6.74175 8.36664 6.97993C8.36664 7.2181 8.56151 7.41298 8.79969 7.41298Z" fill="white"/><path d="M12.3543 7.41298C12.5925 7.41298 12.7874 7.2181 12.7874 6.97993C12.7874 6.74175 12.5925 6.54688 12.3543 6.54688C12.1161 6.54688 11.9213 6.74175 11.9213 6.97993C11.9213 7.2181 12.1161 7.41298 12.3543 7.41298Z" fill="white"/><path d="M14.1334 6.54688C14.0216 6.54688 13.9061 6.59379 13.8267 6.67318C13.7473 6.75257 13.7004 6.86445 13.7004 6.97993C13.7004 7.09541 13.7473 7.20728 13.8267 7.28667C13.9061 7.36606 14.0179 7.41298 14.1334 7.41298C14.2489 7.41298 14.3608 7.36606 14.4402 7.28667C14.5196 7.20728 14.5665 7.09541 14.5665 6.97993C14.5665 6.86445 14.5196 6.75257 14.4402 6.67318C14.3608 6.59379 14.2489 6.54688 14.1334 6.54688Z" fill="white"/><path d="M14.1334 11.8828C13.8953 11.8828 13.7004 12.0777 13.7004 12.3159C13.7004 12.554 13.8953 12.7489 14.1334 12.7489C14.3716 12.7489 14.5665 12.554 14.5665 12.3159C14.5665 12.0741 14.3752 11.8828 14.1334 11.8828Z" fill="white"/><path d="M14.1334 10.1016C13.8953 10.1016 13.7004 10.2964 13.7004 10.5346C13.7004 10.7728 13.8953 10.9677 14.1334 10.9677C14.3716 10.9677 14.5665 10.7728 14.5665 10.5346C14.5665 10.2928 14.3752 10.1016 14.1334 10.1016Z" fill="white"/><path d="M14.1334 8.32812C13.8953 8.32812 13.7004 8.523 13.7004 8.76118C13.7004 8.99935 13.8953 9.19423 14.1334 9.19423C14.3716 9.19423 14.5665 8.99935 14.5665 8.76118C14.5665 8.523 14.3752 8.32812 14.1334 8.32812Z" fill="white"/><path d="M14.1334 13.6641C14.0179 13.6641 13.9061 13.711 13.8267 13.7904C13.7473 13.8698 13.7004 13.9816 13.7004 14.0971C13.7004 14.209 13.7473 14.3245 13.8267 14.4039C13.9061 14.4833 14.0179 14.5302 14.1334 14.5302C14.2489 14.5302 14.3608 14.4833 14.4402 14.4039C14.5196 14.3245 14.5665 14.2126 14.5665 14.0971C14.5665 13.9816 14.5196 13.8698 14.4402 13.7904C14.3608 13.711 14.2489 13.6641 14.1334 13.6641Z" fill="white"/><path d="M12.3543 14.5302C12.5925 14.5302 12.7874 14.3353 12.7874 14.0971C12.7874 13.8589 12.5925 13.6641 12.3543 13.6641C12.1161 13.6641 11.9213 13.8589 11.9213 14.0971C11.9213 14.3389 12.1161 14.5302 12.3543 14.5302Z" fill="white"/><path d="M10.5788 14.5302C10.817 14.5302 11.0119 14.3353 11.0119 14.0971C11.0119 13.8589 10.817 13.6641 10.5788 13.6641C10.3406 13.6641 10.1458 13.8589 10.1458 14.0971C10.1458 14.3389 10.337 14.5302 10.5788 14.5302Z" fill="white"/><path d="M8.79969 14.5302C9.03787 14.5302 9.23274 14.3353 9.23274 14.0971C9.23274 13.8589 9.03787 13.6641 8.79969 13.6641C8.56151 13.6641 8.36664 13.8589 8.36664 14.0971C8.36664 14.3389 8.56151 14.5302 8.79969 14.5302Z" fill="white"/><path d="M7.02058 14.5302C7.13606 14.5302 7.24793 14.4833 7.32732 14.4039C7.40671 14.3245 7.45363 14.2126 7.45363 14.0971C7.45363 13.9816 7.40671 13.8698 7.32732 13.7904C7.24793 13.711 7.13606 13.6641 7.02058 13.6641C6.9051 13.6641 6.79322 13.711 6.71383 13.7904C6.63444 13.8698 6.58752 13.9816 6.58752 14.0971C6.58752 14.209 6.63444 14.3245 6.71383 14.4039C6.79683 14.4833 6.9051 14.5302 7.02058 14.5302Z" fill="white"/><path d="M7.02058 12.7489C7.25875 12.7489 7.45363 12.554 7.45363 12.3159C7.45363 12.0777 7.25875 11.8828 7.02058 11.8828C6.7824 11.8828 6.58752 12.0777 6.58752 12.3159C6.58752 12.554 6.7824 12.7489 7.02058 12.7489Z" fill="white"/><path d="M7.02058 10.9677C7.25875 10.9677 7.45363 10.7728 7.45363 10.5346C7.45363 10.2964 7.25875 10.1016 7.02058 10.1016C6.7824 10.1016 6.58752 10.2964 6.58752 10.5346C6.58752 10.7728 6.7824 10.9677 7.02058 10.9677Z" fill="white"/><path d="M7.02058 9.19423C7.25875 9.19423 7.45363 8.99935 7.45363 8.76118C7.45363 8.523 7.25875 8.32812 7.02058 8.32812C6.7824 8.32812 6.58752 8.523 6.58752 8.76118C6.58752 8.99935 6.7824 9.19423 7.02058 9.19423Z" fill="white"/></g><defs><clipPath id="c-change-photo-clip"><rect width="16.2899" height="16.3149" fill="white" transform="translate(6.55505 6.54688)"/></clipPath></defs></svg>';
    var spinnerSvg = '<svg class="c-pdp-upload__spinner" xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none"><circle cx="14.5" cy="14.5" r="13" stroke="white" stroke-width="3"/><mask id="path-col-inside" fill="white"><path d="M-1.26763e-06 14.5C-1.4341e-06 12.5958 0.375052 10.7103 1.10374 8.95109C1.83244 7.19187 2.9005 5.5934 4.24695 4.24695C5.5934 2.9005 7.19187 1.83244 8.95109 1.10375C10.7103 0.375055 12.5958 1.4341e-06 14.5 1.26763e-06L14.5 2.97312C12.9863 2.97312 11.4874 3.27127 10.0889 3.85056C8.69035 4.42983 7.41963 5.2789 6.34926 6.34927C5.27889 7.41964 4.42983 8.69035 3.85055 10.0889C3.27127 11.4874 2.97312 12.9863 2.97312 14.5L-1.26763e-06 14.5Z"/></mask><path d="M-1.26763e-06 14.5C-1.4341e-06 12.5958 0.375052 10.7103 1.10374 8.95109C1.83244 7.19187 2.9005 5.5934 4.24695 4.24695C5.5934 2.9005 7.19187 1.83244 8.95109 1.10375C10.7103 0.375055 12.5958 1.4341e-06 14.5 1.26763e-06L14.5 2.97312C12.9863 2.97312 11.4874 3.27127 10.0889 3.85056C8.69035 4.42983 7.41963 5.2789 6.34926 6.34927C5.27889 7.41964 4.42983 8.69035 3.85055 10.0889C3.27127 11.4874 2.97312 12.9863 2.97312 14.5L-1.26763e-06 14.5Z" stroke="#0F1726" stroke-width="6" mask="url(#path-col-inside)"/></svg>';

    modal = document.createElement('div');
    modal.id = 'c-col-upload-modal';
    modal.className = 'c-col-upload-modal';
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    modal.style.display = 'none';

    modal.innerHTML = [
      '<div class="c-col-upload-modal__overlay"></div>',
      '<div class="c-col-upload-modal__dialog">',
        '<button class="c-col-upload-modal__close" type="button" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none"><g clip-path="url(#c-modal-close-clip)"><path d="M13.5 0C6.0558 0 0 6.0558 0 13.5C0 20.9442 6.0558 27 13.5 27C20.9442 27 27 20.9442 27 13.5C27 6.0558 20.9442 0 13.5 0ZM18.4715 16.8806C18.9112 17.3206 18.9112 18.0314 18.4715 18.4715C18.2521 18.6908 17.9641 18.801 17.6759 18.801C17.3879 18.801 17.0999 18.6908 16.8806 18.4715L13.5 15.0907L10.1194 18.4715C9.90005 18.6908 9.61208 18.801 9.3241 18.801C9.03591 18.801 8.74793 18.6908 8.52855 18.4715C8.08875 18.0314 8.08875 17.3206 8.52855 16.8806L11.9093 13.5L8.52855 10.1194C8.08875 9.67944 8.08875 8.96855 8.52855 8.52855C8.96855 8.08875 9.67944 8.08875 10.1194 8.52855L13.5 11.9093L16.8806 8.52855C17.3206 8.08875 18.0314 8.08875 18.4715 8.52855C18.9112 8.96855 18.9112 9.67944 18.4715 10.1194L15.0907 13.5L18.4715 16.8806Z" fill="#0B1F43"/></g><defs><clipPath id="c-modal-close-clip"><rect width="27" height="27" fill="white"/></clipPath></defs></svg></button>',
        '<div class="c-col-upload-modal__body">',
          '<div class="c-pdp-upload" id="c-col-pdp-upload">',

            // Step 1: Upload
            '<div class="c-pdp-upload__step c-pdp-upload__step--upload" data-step="upload">',
              '<div class="c-pdp-upload__dropzone">',
                '<label for="c-col-image-input" class="c-pdp-upload__dropzone-label">',
                  '<svg class="c-pdp-upload__camera-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M38.3337 31.6667C38.3337 32.5507 37.9825 33.3986 37.3573 34.0237C36.7322 34.6488 35.8844 35 35.0003 35H5.00033C4.11627 35 3.26842 34.6488 2.6433 34.0237C2.01818 33.3986 1.66699 32.5507 1.66699 31.6667V13.3333C1.66699 12.4493 2.01818 11.6014 2.6433 10.9763C3.26842 10.3512 4.11627 10 5.00033 10H11.667L15.0003 5H25.0003L28.3337 10H35.0003C35.8844 10 36.7322 10.3512 37.3573 10.9763C37.9825 11.6014 38.3337 12.4493 38.3337 13.3333V31.6667Z" stroke="#0B1F43" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.9997 28.3333C23.6816 28.3333 26.6663 25.3486 26.6663 21.6667C26.6663 17.9848 23.6816 15 19.9997 15C16.3178 15 13.333 17.9848 13.333 21.6667C13.333 25.3486 16.3178 28.3333 19.9997 28.3333Z" stroke="#0B1F43" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                  '<span class="c-pdp-upload__dropzone-text">Tap to add photo</span>',
                  '<span class="c-pdp-upload__dropzone-subtext">From Gallery</span>',
                '</label>',
                '<input type="file" id="c-col-image-input" accept="image/jpeg, image/png, image/jpg" class="c-pdp-upload__file-input">',
              '</div>',
              '<p class="c-col-upload-modal__dropzone-tagline">Turn your photo into custom wall art.</p>',
            '</div>',

            // Step 2: Preview
            '<div class="c-pdp-upload__step c-pdp-upload__step--preview" data-step="preview" style="display:none;">',
              '<div class="c-pdp-upload__header c-pdp-upload__header--done">',
                '<span class="c-pdp-upload__step-check"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none"><path d="M16.5542 0.3625C16.0708 -0.120833 15.3458 -0.120833 14.8625 0.3625L5.8 9.425L2.05417 5.67917C1.57083 5.19583 0.845833 5.19583 0.3625 5.67917C-0.120833 6.1625 -0.120833 6.8875 0.3625 7.37083L4.95417 11.9625C5.19583 12.2042 5.4375 12.325 5.8 12.325C6.1625 12.325 6.40417 12.2042 6.64583 11.9625L16.5542 2.05417C17.0375 1.57083 17.0375 0.845833 16.5542 0.3625Z" fill="white"/></svg></span>',
                '<span class="c-pdp-upload__step-label">Upload your photo</span>',
              '</div>',
              '<div class="c-pdp-upload__photo-preview">',
                '<img class="c-pdp-upload__thumb" id="c-col-thumb" src="" alt="">',
                '<div class="c-pdp-upload__photo-status">',
                  '<span class="c-pdp-upload__photo-ready">' + checkSvgGreen + ' Photo ready</span>',
                  '<label for="c-col-image-input-replace" class="c-pdp-upload__change-photo"><span class="c-pdp-upload__status-icon c-pdp-upload__status-icon--change">' + changePhotoIcon + '</span><span class="c-pdp-upload__status-text">Change photo</span></label>',
                  '<input type="file" id="c-col-image-input-replace" accept="image/jpeg, image/png, image/jpg" class="c-pdp-upload__file-input">',
                '</div>',
              '</div>',
            '</div>',

            // Personalize
            '<div class="c-pdp-upload__personalize" id="c-col-personalize" style="display:none;">',
              '<p class="c-pdp-upload__personalize-title">Let\'s personalize your child\'s adventure!</p>',
              '<input type="number" id="c-col-age-input" class="c-pdp-upload__age-input" placeholder="Enter Child\'s Age" min="1" max="100">',
            '</div>',

            // Step 3: Generating
            '<div class="c-pdp-upload__step c-pdp-upload__step--generating" data-step="generating" style="display:none;">',
              '<div class="c-pdp-upload__header c-pdp-upload__header--done">',
                '<span class="c-pdp-upload__step-check"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none"><path d="M16.5542 0.3625C16.0708 -0.120833 15.3458 -0.120833 14.8625 0.3625L5.8 9.425L2.05417 5.67917C1.57083 5.19583 0.845833 5.19583 0.3625 5.67917C-0.120833 6.1625 -0.120833 6.8875 0.3625 7.37083L4.95417 11.9625C5.19583 12.2042 5.4375 12.325 5.8 12.325C6.1625 12.325 6.40417 12.2042 6.64583 11.9625L16.5542 2.05417C17.0375 1.57083 17.0375 0.845833 16.5542 0.3625Z" fill="white"/></svg></span>',
                '<span class="c-pdp-upload__step-label">Upload your photo</span>',
              '</div>',
              '<div class="c-pdp-upload__photo-preview c-pdp-upload__photo-preview--small">',
                '<img class="c-pdp-upload__thumb" id="c-col-thumb-gen" src="" alt="">',
                '<div class="c-pdp-upload__photo-status">',
                  '<span class="c-pdp-upload__photo-ready">' + checkSvgGreen + ' Photo ready</span>',
                  '<label for="c-col-image-input-replace" class="c-pdp-upload__change-photo"><span class="c-pdp-upload__status-icon c-pdp-upload__status-icon--change">' + changePhotoIcon + '</span><span class="c-pdp-upload__status-text">Change photo</span></label>',
                '</div>',
              '</div>',
            '</div>',

            '<p class="c-pdp-upload__safe-text" id="c-col-safe-text" style="display:none;">\uD83D\uDD12 Your photo is safe · Deleted in 24hrs</p>',

            // Progress
            '<div class="c-pdp-upload__generation-progress" id="c-col-generation-progress" style="display:none;">',
              '<p class="c-pdp-upload__generation-label">' + spinnerSvg + '<span id="c-col-generation-label-text">Unleashing creativity...</span></p>',
              '<div class="c-pdp-upload__progress"><div class="c-pdp-upload__progress-bar"><div class="c-pdp-upload__progress-fill" id="c-col-progress-fill"></div></div><span class="c-pdp-upload__progress-text" id="c-col-progress-text">0%</span></div>',
            '</div>',

            // Step 4: Result
            '<div class="c-pdp-upload__step c-pdp-upload__step--result" data-step="result" style="display:none;">',
              '<div class="c-pdp-upload__photo-preview c-pdp-upload__photo-preview--small">',
                '<img class="c-pdp-upload__thumb" id="c-col-thumb-result" src="" alt="">',
                '<div class="c-pdp-upload__photo-status">',
                  '<span class="c-pdp-upload__photo-ready">' + checkSvgGreen + ' Photo ready</span>',
                  '<label for="c-col-image-input-replace" class="c-pdp-upload__change-photo"><span class="c-pdp-upload__status-icon c-pdp-upload__status-icon--change">' + changePhotoIcon + '</span><span class="c-pdp-upload__status-text">Change photo</span></label>',
                '</div>',
              '</div>',
            '</div>',

            // Result content
            '<div class="c-pdp-upload__result-content" id="c-col-result-content" style="display:none;">',
              '<h3 class="c-pdp-upload__result-title">Your Preview is ready!</h3>',
              '<div class="c-pdp-upload__generated-image-wrapper">',
                '<img class="c-pdp-upload__generated-image" id="c-col-generated-img" src="" alt="Generated portrait">',
                '<div class="c-pdp-upload__watermark-overlay"><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div></div>',
                '<button type="button" class="c-pdp-upload__zoom-btn c-col-zoom-btn" id="c-col-zoom-btn" aria-label="Zoom image"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22.9862 22.1732L16.426 15.4704C19.4149 11.7547 19.2116 6.23899 15.8151 2.76877C12.202 -0.922923 6.32301 -0.922923 2.70986 2.76877C-0.903286 6.46046 -0.903286 12.4672 2.70986 16.1589C6.10533 19.6282 11.503 19.8383 15.1412 16.7831L21.7015 23.4859C22.0562 23.8484 22.6314 23.8484 22.9862 23.4859C23.341 23.1234 23.341 22.5357 22.9862 22.1732ZM14.5304 14.8462C11.6257 17.8141 6.89936 17.814 3.99464 14.8462C1.08992 11.8784 1.08992 7.0493 3.99464 4.08143C6.89927 1.11371 11.6256 1.11347 14.5304 4.08143C17.4351 7.0493 17.4351 11.8784 14.5304 14.8462Z" fill="#0B1F43"/><path d="M13.7148 8.53698H10.1752V4.92041C10.1752 4.40776 9.76847 3.99219 9.26673 3.99219C8.76499 3.99219 8.35825 4.40776 8.35825 4.92041V8.53698H4.81863C4.31689 8.53698 3.91016 8.95256 3.91016 9.46521C3.91016 9.97785 4.31689 10.3934 4.81863 10.3934H8.35825V14.01C8.35825 14.5226 8.76499 14.9382 9.26673 14.9382C9.76847 14.9382 10.1752 14.5226 10.1752 14.01V10.3934H13.7148C14.2166 10.3934 14.6233 9.97785 14.6233 9.46521C14.6233 8.95256 14.2166 8.53698 13.7148 8.53698Z" fill="#0B1F43"/></svg></button>',
              '</div>',
              '<p class="c-pdp-upload__watermark-note">The watermark will be removed after your purchase</p>',
              '<p class="c-pdp-upload__retry-text">Not what you expected?<br><button type="button" class="c-pdp-upload__retry-btn" id="c-col-retry-btn">Try Different Photo</button></p>',
              '<div class="c-col-upload-modal__variants">',
                '<p class="c-col-upload-modal__variants-label">Choose Your Size:</p>',
                '<div class="c-col-upload-modal__variant-list" id="c-col-variant-list"></div>',
              '</div>',
              '<div class="c-col-upload-modal__selected-price" id="c-col-selected-price"></div>',
              '<div id="c-col-payment-terms"></div>',
              '<button type="button" class="c-pdp-upload__atc-btn button button--primary button--full-width" id="c-col-atc-btn" disabled>ADD TO CART</button>',
            '</div>',

            '<button type="button" class="c-pdp-upload__create-btn button button--primary button--full-width" id="c-col-create-btn" style="display:none">\uD83C\uDFA8 Create my Portrait</button>',

          '</div>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    closeBtn = modal.querySelector('.c-col-upload-modal__close');
    var container = document.getElementById('c-col-pdp-upload');

    stepUpload = container.querySelector('[data-step="upload"]');
    stepPreview = container.querySelector('[data-step="preview"]');
    stepGenerating = container.querySelector('[data-step="generating"]');
    stepResult = container.querySelector('[data-step="result"]');

    imageInput = document.getElementById('c-col-image-input');
    imageInputReplace = document.getElementById('c-col-image-input-replace');
    thumbPreview = document.getElementById('c-col-thumb');
    thumbGen = document.getElementById('c-col-thumb-gen');
    thumbResult = document.getElementById('c-col-thumb-result');
    ageInput = document.getElementById('c-col-age-input');
    createBtn = document.getElementById('c-col-create-btn');
    atcBtn = document.getElementById('c-col-atc-btn');
    progressFill = document.getElementById('c-col-progress-fill');
    progressText = document.getElementById('c-col-progress-text');
    generatedImg = document.getElementById('c-col-generated-img');
    generationProgress = document.getElementById('c-col-generation-progress');
    resultContent = document.getElementById('c-col-result-content');
    personalizeSection = document.getElementById('c-col-personalize');
    variantList = document.getElementById('c-col-variant-list');

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.c-col-upload-modal__dialog')) closeModal();
    });

    // Lightbox
    var lightbox = document.createElement('div');
    lightbox.className = 'c-col-lightbox';
    lightbox.id = 'c-col-lightbox';
    lightbox.innerHTML = '<div class="c-col-lightbox__inner"><div class="c-col-lightbox__img-wrap"><img class="c-col-lightbox__img" id="c-col-lightbox-img" src="" alt="Preview"><div class="c-pdp-upload__watermark-overlay"><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div><div class="c-pdp-upload__watermark-row"><span>WonderMe</span><span>WonderMe</span><span>WonderMe</span></div></div></div><button type="button" class="c-col-lightbox__close" id="c-col-lightbox-close" aria-label="Close"><span>&times;</span></button></div>';
    document.body.appendChild(lightbox);

    document.getElementById('c-col-zoom-btn').addEventListener('click', function () {
      var src = document.getElementById('c-col-generated-img').src;
      document.getElementById('c-col-lightbox-img').src = src;
      lightbox.style.display = 'flex';
    });
    document.getElementById('c-col-lightbox-close').addEventListener('click', function () {
      lightbox.style.display = 'none';
    });
    lightbox.addEventListener('click', function (e) {
      if (!e.target.closest('.c-col-lightbox__inner')) lightbox.style.display = 'none';
    });
    imageInput.addEventListener('change', function (e) { handleImageUpload(e.target.files[0]); imageInput.value = ''; });
    imageInputReplace.addEventListener('change', function (e) { handleImageUpload(e.target.files[0]); imageInputReplace.value = ''; });
    ageInput.addEventListener('input', function () {
      updateButtonStates();
      hideCreateBtnError();
    });
    createBtn.addEventListener('click', function () {
      var hasPhoto = !!uploadedBase64;
      var hasAge = ageInput && ageInput.value && parseInt(ageInput.value, 10) > 0;

      if (!hasPhoto && !hasAge) {
        showCreateBtnError('Please upload a photo and enter child\'s age');
        return;
      }
      if (!hasPhoto) {
        showCreateBtnError('Please upload a photo first');
        return;
      }
      if (!hasAge) {
        showCreateBtnError('Please enter child\'s age');
        return;
      }

      hideCreateBtnError();
      startGeneration();
    });
    atcBtn.addEventListener('click', handleAtc);
    document.getElementById('c-col-retry-btn').addEventListener('click', resetToUpload);
  }

  // Inline error message helper for the Var B Create button
  // Popup/toast error message for the Var B Create button
  // Popup/toast error message positioned above the Var B Create button
  function showCreateBtnError(message) {
    var popup = document.getElementById('c-col-error-popup');
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'c-col-error-popup';
      popup.style.cssText = [
        'position:fixed',
        'background:#fff',
        'color:#d32f2f',
        'border:1.5px solid #d32f2f',
        'border-radius:10px',
        'padding:10px 16px',
        'font-size:14px',
        'font-weight:600',
        'box-shadow:0 6px 24px rgba(0,0,0,0.18)',
        'z-index:100000',
        'opacity:0',
        'pointer-events:none',
        'transition:opacity 0.25s ease, transform 0.25s ease',
        'display:inline-flex',
        'align-items:center',
        'gap:10px',
        'line-height:1.2',
        'width:max-content',
        'max-width:calc(100vw - 24px)',
        'white-space:nowrap'
      ].join(';');

      var icon = document.createElement('span');
      icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#d32f2f"><path d="M12 2L1 21h22L12 2zm0 6l7.53 13H4.47L12 8zm-1 4v4h2v-4h-2zm0 5v2h2v-2h-2z"/></svg>';
      icon.style.cssText = 'flex:0 0 auto;display:inline-flex;align-items:center;';

      var textEl = document.createElement('span');
      textEl.id = 'c-col-error-popup-text';

      popup.appendChild(icon);
      popup.appendChild(textEl);
      document.body.appendChild(popup);
    }

    var textEl = document.getElementById('c-col-error-popup-text');
    if (textEl) textEl.textContent = message;

    var anchorBtn = createBtn && createBtn.offsetParent !== null ? createBtn : null;

    popup.style.whiteSpace = 'nowrap';
    popup.style.width = 'max-content';
    popup.style.opacity = '0';

    var naturalWidth = popup.offsetWidth;
    var maxAllowed = window.innerWidth - 24;
    if (naturalWidth > maxAllowed) {
      popup.style.whiteSpace = 'normal';
      popup.style.width = maxAllowed + 'px';
    }

    if (anchorBtn) {
      var rect = anchorBtn.getBoundingClientRect();
      var popupWidth = popup.offsetWidth;
      var popupHeight = popup.offsetHeight;

      var btnCenterX = rect.left + rect.width / 2;
      var left = btnCenterX - popupWidth / 2;
      if (left < 12) left = 12;
      if (left + popupWidth > window.innerWidth - 12) {
        left = window.innerWidth - popupWidth - 12;
      }

      var top = rect.top - popupHeight - 12;
      if (top < 8) {
        top = rect.bottom + 12;
      }

      popup.style.left = left + 'px';
      popup.style.top = top + 'px';
      popup.style.transform = 'translateY(-8px)';
    } else {
      popup.style.left = '50%';
      popup.style.top = '20px';
      popup.style.transform = 'translate(-50%, -8px)';
    }

    requestAnimationFrame(function () {
      popup.style.opacity = '1';
      popup.style.transform = anchorBtn ? 'translateY(0)' : 'translate(-50%, 0)';
    });

    clearTimeout(showCreateBtnError._t);
    showCreateBtnError._t = setTimeout(function () {
      if (popup) {
        popup.style.opacity = '0';
        popup.style.transform = anchorBtn ? 'translateY(-8px)' : 'translate(-50%, -8px)';
      }
    }, 3500);
  }

  function hideCreateBtnError() {
    var popup = document.getElementById('c-col-error-popup');
    if (popup) popup.style.opacity = '0';
  }

  function openModal(btn) {
    productHandle = btn.dataset.productHandle || null;
    productId = btn.dataset.productId || null;
    gender = btn.dataset.gender || null;
    taggerPrompt = btn.dataset.taggerPrompt || null;
    category = btn.dataset.category || null;
    templateName = btn.dataset.templateName || null;
    resetToUpload();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    if (productHandle) {
      fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.variants && data.variants.length) {
            cachedVariants = data.variants;
            renderVariants(cachedVariants);
            if (!selectedVariantId) {
              var first = data.variants.find(function (v) { return v.available; });
              selectedVariantId = first ? first.id : data.variants[0].id;
            }
          }
        });
    }
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    clearGenTimers();
  }

  function resetToUpload() {
    uploadedBase64 = null; selectedImageURL = ''; selectedVariantId = null; isAddingToCart = false;
    clearGenTimers();
    showStep(stepUpload);
    if (personalizeSection) personalizeSection.style.display = 'none';
    if (generationProgress) generationProgress.style.display = 'none';
    if (resultContent) resultContent.style.display = 'none';
    var safeText = document.getElementById('c-col-safe-text');
    if (safeText) safeText.style.display = '';
    hideCreateBtnError();
    createBtn.style.display = 'none';
    atcBtn.style.display = 'none'; atcBtn.disabled = true; atcBtn.textContent = 'ADD TO CART';
    if (variantList) variantList.innerHTML = '';
    ageInput.value = '';
  }

  function showStep(step) {
    [stepUpload, stepPreview, stepGenerating, stepResult].forEach(function (el) { el.style.display = 'none'; });
    step.style.display = '';
  }

  function updateProgress(p) {
    var val = Math.max(0, Math.min(Math.floor(p), 100));
    progressFill.style.width = val + '%';
    progressText.textContent = val + '%';
    progressText.style.left = val + '%';
    var labelEl = document.getElementById('c-col-generation-label-text');
    if (labelEl) { for (var i = 0; i < generationLabels.length; i++) { if (val <= generationLabels[i].max) { labelEl.textContent = generationLabels[i].text; break; } } }
  }

  // Button is always enabled; validation happens on click instead.
  function updateButtonStates() {
    if (createBtn) createBtn.disabled = false;
  }

  function clearGenTimers() { genTimers.forEach(function (id) { clearInterval(id); clearTimeout(id); }); genTimers = []; }

  function compressImage(src, maxSize, quality) {
    maxSize = maxSize || 2000; quality = quality || 0.7;
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var w = img.width, h = img.height;
        if (w > maxSize || h > maxSize) { if (w > h) { h = Math.round(h * maxSize / w); w = maxSize; } else { w = Math.round(w * maxSize / h); h = maxSize; } }
        var c = document.createElement('canvas'); c.width = w; c.height = h; c.getContext('2d').drawImage(img, 0, 0, w, h);
        resolve(c.toDataURL('image/jpeg', quality));
      };
      img.onerror = reject; img.src = src;
    });
  }

  function base64ToBlob(b64) {
    var parts = b64.split(','), bytes = atob(parts[1]), arr = [];
    for (var i = 0; i < bytes.length; i++) arr.push(bytes.charCodeAt(i));
    return new Blob([new Uint8Array(arr)], { type: 'image/jpeg' });
  }

  function handleImageUpload(file) {
    if (!file || !file.type.startsWith('image')) return;
    selectedImageURL = ''; clearGenTimers();
    if (generationProgress) generationProgress.style.display = 'none';
    if (resultContent) resultContent.style.display = 'none';
    atcBtn.style.display = 'none'; atcBtn.disabled = true;
    hideCreateBtnError();
    var reader = new FileReader();
    reader.onload = function (e) {
      compressImage(e.target.result).then(function (compressed) {
        uploadedBase64 = compressed;
        [thumbPreview, thumbGen, thumbResult].forEach(function (el) { if (el) el.src = compressed; });
        showStep(stepPreview);
        if (personalizeSection) personalizeSection.style.display = '';
        var safeText = document.getElementById('c-col-safe-text');
        if (safeText) safeText.style.display = '';
        createBtn.style.display = ''; updateButtonStates();
      });
    };
    reader.readAsDataURL(file);
  }

  function startGeneration() {
    clearGenTimers(); showStep(stepGenerating);
    if (generationProgress) generationProgress.style.display = '';
    if (personalizeSection) personalizeSection.style.display = 'none';
    var safeText = document.getElementById('c-col-safe-text');
    if (safeText) safeText.style.display = 'block';
    createBtn.style.display = 'none'; atcBtn.style.display = 'none';
    var progress = 0; updateProgress(0);
    compressImage(uploadedBase64, 2000, 0.7).then(function (compressed) {
      var blob = base64ToBlob(compressed);
      var file = new File([blob], 'edited-image.jpg', { type: 'image/jpeg' });
      var uniqueUserId = localStorage.getItem('uniqueUserId');
      if (!uniqueUserId) { uniqueUserId = Math.floor(Math.random() * 1000000).toString(); localStorage.setItem('uniqueUserId', uniqueUserId); }
      var uploadedCount = parseInt(localStorage.getItem('uploadedCount') || '0', 10) + 1;
      localStorage.setItem('uploadedCount', uploadedCount);
      var userId = uniqueUserId + '_' + uploadedCount;
      var age = ageInput ? ageInput.value : '';
      var formData = new FormData();
      formData.append('user_id', userId); formData.append('gender', gender); formData.append('age', age);
      formData.append('category', category); formData.append('template_name', templateName); formData.append('prompt', taggerPrompt); formData.append('user_image', file);
      var isCompleted = false, pollingFailed = false;
      fetch(API_URL + PROCESS_IMG_ENDPOINT, { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          var progressInterval = setInterval(function () {
            if (progress < 60) progress += 1;
            progress = Math.min(progress, 60); updateProgress(progress);
            if (progress >= 60) { clearInterval(progressInterval); pollStatus(); }
          }, 225);
          genTimers.push(progressInterval);
          var pollingDelay = 1000;
          function pollStatus() {
            if (isCompleted || pollingFailed) return;
            fetch(API_URL + TASK_STATUS_ENDPOINT + userId)
              .then(function (r) { return r.json(); })
              .then(function (data) {
                if (progress < 100) {
                  var pi = setInterval(function () { progress += 1; progress = Math.min(progress, 100); updateProgress(progress); }, 720);
                  genTimers.push(pi); pollingDelay = Math.min(pollingDelay * 1.5, 5000);
                  genTimers.push(setTimeout(pollStatus, pollingDelay));
                } else if (progress >= 100 && data.status === 'processing') {
                  genTimers.push(setTimeout(pollStatus, pollingDelay));
                } else if (data.status === 'success') {
                  isCompleted = true; clearGenTimers(); updateProgress(100); onGenerationComplete(data.message);
                } else if (data.status === 'failed') {
                  pollingFailed = true; clearGenTimers(); onGenerationError();
                }
              })
              .catch(function () { pollingFailed = true; clearGenTimers(); onGenerationError(); });
          }
        })
        .catch(function () { onGenerationError(); });
    });
  }

  function onGenerationComplete(imageUrl) {
    if (!imageUrl) { onGenerationError(); return; }
    selectedImageURL = imageUrl; generatedImg.src = selectedImageURL;
    if (generationProgress) generationProgress.style.display = 'none';
    var safeTextEl = document.getElementById('c-col-safe-text');
    if (safeTextEl) safeTextEl.style.display = 'none';
    if (variantList && variantList.innerHTML === '' && cachedVariants) {
      renderVariants(cachedVariants);
    }
    [stepUpload, stepPreview, stepGenerating, stepResult].forEach(function (el) { el.style.display = 'none'; });
    if (resultContent) resultContent.style.display = '';
    createBtn.style.display = 'none';
    atcBtn.style.display = '';
    atcBtn.disabled = !selectedVariantId;
  }

  function onGenerationError() {
    if (generationProgress) generationProgress.style.display = 'none';
    if (resultContent) resultContent.style.display = 'none';
    if (personalizeSection) personalizeSection.style.display = '';
    var safeText = document.getElementById('c-col-safe-text');
    if (safeText) safeText.style.display = '';
    showStep(stepPreview); createBtn.style.display = ''; atcBtn.style.display = 'none';
    updateButtonStates(); alert('Error generating image. Please try again.');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updatePaymentTerms(variantId) {
    var ptWrapper = document.getElementById('c-col-payment-terms');
    if (!ptWrapper || !productId) return;

    // If already rendered, just update variant-id in place — no DOM removal = no flash
    var existing = ptWrapper.querySelector('shopify-payment-terms');
    if (existing) {
      existing.setAttribute('variant-id', variantId);
      return;
    }

    // First render — clone from hidden source
    var sourceEl = document.querySelector('.c-col-payment-terms-source[data-product-id="' + productId + '"]');
    if (!sourceEl) return;
    var ptEl = sourceEl.querySelector('shopify-payment-terms');
    if (!ptEl) return;
    var clone = ptEl.cloneNode(true);
    clone.setAttribute('variant-id', variantId);
    ptWrapper.appendChild(clone);
  }

  var VARIANT_CAPTION = 'Premium Gallery Wrapped (1.5" Wood Frame)';

  function buildVariantCardHTML(v) {
    return '<span class="quantity-break__label-text">' + v.title + '</span>'
      + '<span class="quantity-break__caption">' + VARIANT_CAPTION + '</span>';
  }

  function updateSelectedPrice(variant) {
    var priceEl = document.getElementById('c-col-selected-price');
    if (!priceEl || !variant) return;
    var price = variant.price;
    var comparePrice = variant.compare_at_price;
    var isOnSale = comparePrice && comparePrice > price;
    var priceFmt = formatMoney(price);
    var compareFmt = isOnSale ? formatMoney(comparePrice) : null;
    var pctSaved = isOnSale ? Math.round((comparePrice - price) / comparePrice * 100) : 0;
    var discountSvg = '<svg aria-hidden="true" focusable="false" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>';
    var html;
    if (isOnSale) {
      html = '<div class="price price--large price--on-sale price--show-badge">'
        + '<div class="price__container">'
          + '<div class="price__sale price__sale--price-second">'
            + '<span class="price__compare-price">'
              + '<s class="price-item price-item--regular main-compare-price accent-color-text">' + compareFmt + '</s>'
            + '</span>'
            + '<span class="price-item price-item--sale price-item--last main-price accent-color-accent-1">' + priceFmt + '</span>'
          + '</div>'
        + '</div>'
        + '<span class="badge price__badge-sale color-background-2">' + discountSvg + '<span class="nowrap">' + pctSaved + '% OFF</span></span>'
      + '</div>';
    } else {
      html = '<div class="price price--large">'
        + '<div class="price__container">'
          + '<div class="price__regular">'
            + '<span class="visually-hidden visually-hidden--inline">Regular price</span>'
            + '<span class="price-item price-item--regular main-price accent-color-accent-1">' + priceFmt + '</span>'
          + '</div>'
        + '</div>'
      + '</div>';
    }
    priceEl.innerHTML = html;
    priceEl.style.display = '';
  }

  function renderVariants(variants) {
    if (!variantList) return;
    variantList.innerHTML = '';
    var filtered = variants.filter(function (v) { return v.title !== '24" x 32" Royal Canvas'; });
    var initialVariant = null;
    filtered.forEach(function (v, i) {
      var opt = document.createElement('div');
      opt.className = 'c-col-upload-modal__variant-opt' + (v.available ? '' : ' c-col-upload-modal__variant-opt--unavailable');
      opt.dataset.variantId = v.id;
      opt.innerHTML = buildVariantCardHTML(v);
      if (v.available) {
        opt.addEventListener('click', function () {
          variantList.querySelectorAll('.c-col-upload-modal__variant-opt').forEach(function (o) { o.classList.remove('selected'); });
          opt.classList.add('selected');
          selectedVariantId = v.id;
          if (selectedImageURL) atcBtn.disabled = false;
          updateSelectedPrice(v);
          updatePaymentTerms(v.id);
        });
        if (i === 1 || (i === 0 && filtered.length === 1)) {
          opt.classList.add('selected');
          selectedVariantId = v.id;
          initialVariant = v;
        }
      }
      variantList.appendChild(opt);
    });
    if (initialVariant) { updateSelectedPrice(initialVariant); updatePaymentTerms(initialVariant.id); }
  }

  function handleAtc() {
    if (!selectedVariantId || !selectedImageURL || isAddingToCart) return;
    isAddingToCart = true; atcBtn.disabled = true; atcBtn.textContent = 'Adding...';
    var colProps = { _selected_image: selectedImageURL };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1, properties: colProps }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        localStorage.setItem('cartUpdated', 'true');
        var path = window.location.pathname;
        var match = path.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i);
        window.location.href = (match ? match[0] : '') + '/';
      })
      .catch(function () { isAddingToCart = false; atcBtn.disabled = false; atcBtn.textContent = 'ADD TO CART'; alert('Error adding to cart. Please try again.'); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.c-upload-img-varB-btn')) return;
    buildModal();
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.c-upload-img-varB-btn');
      if (btn) { e.preventDefault(); e.stopPropagation(); openModal(btn); }
    }, true);
  });
})();

// Sticky ATC - Image Upload
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var atcBtn = document.querySelector('.upload-atc');
    if (!atcBtn) return;

    // Create sticky bar — append to body so position:fixed always works
    var stickyBar = document.createElement('div');
    stickyBar.id = 'c-sticky-atc';
    // All critical styles inline — never depends on external CSS loading
    stickyBar.style.cssText = [
      'position:fixed',
      'bottom:0',
      'left:0',
      'right:0',
      'z-index:9999',
      'background:#fff',
      'padding:14px 20px',
      'box-shadow:0 -4px 20px rgba(0,0,0,0.12)',
      'transform:translateY(100%)',
      'transition:transform 0.3s ease',
      'display:none'
    ].join(';');

    var stickyBtn = document.createElement('button');
    stickyBtn.className = atcBtn.className;
    stickyBtn.textContent = atcBtn.textContent.trim();
    stickyBtn.disabled = true;
    stickyBtn.style.cssText = 'width:100%;max-width:560px;margin:0 auto;display:block';

    stickyBar.appendChild(stickyBtn);
    document.body.appendChild(stickyBar);

    function isStep3Active() {
      return document.querySelector('.upload-step-3.active') !== null;
    }

    function syncDisabled() {
      stickyBtn.disabled = atcBtn.disabled;
    }

    function showSticky() {
      stickyBar.style.display = 'block';
      requestAnimationFrame(function () {
        stickyBar.style.transform = 'translateY(0)';
      });
    }

    function hideSticky() {
      stickyBar.style.transform = 'translateY(100%)';
      setTimeout(function () {
        if (stickyBar.style.transform === 'translateY(100%)') {
          stickyBar.style.display = 'none';
        }
      }, 300);
    }

    // Mirror disabled state from original button
    new MutationObserver(syncDisabled).observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });

    // Clicking sticky triggers the original button
    stickyBtn.addEventListener('click', function () {
      if (!atcBtn.disabled) atcBtn.click();
    });

    // Watch ATC button visibility
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!isStep3Active()) {
          hideSticky();
          return;
        }
        if (!entry.isIntersecting) {
          syncDisabled();
          showSticky();
        } else {
          hideSticky();
        }
      });
    }, { threshold: 0 }).observe(atcBtn);

    // Re-evaluate when step 3 becomes active/inactive
    var step3El = document.querySelector('.upload-step-3');
    if (step3El) {
      new MutationObserver(function () {
        if (!isStep3Active()) {
          hideSticky();
        } else {
          var rect = atcBtn.getBoundingClientRect();
          var inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (!inView) {
            syncDisabled();
            showSticky();
          }
        }
      }).observe(step3El, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();



// Skip "Digital Portrait (Instant Download)" as default selection on PDP
(function () {
  function skipDigitalPortraitDefault() {
    if (!window.location.pathname.includes('/products/')) return;
    var digitalInput = document.querySelector('input[value="Digital Portrait (Instant Download)"]');
    if (!digitalInput || !digitalInput.checked) return;
    var container = digitalInput.closest('fieldset') || digitalInput.parentElement;
    if (!container) return;
    var allInputs = container.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < allInputs.length; i++) {
      var inp = allInputs[i];
      if (
        inp !== digitalInput &&
        !inp.disabled &&
        !inp.classList.contains('non-existent') &&
        !inp.classList.contains('unavailable')
      ) {
        inp.click();
        break;
      }
    }
  }
  document.addEventListener('DOMContentLoaded', skipDigitalPortraitDefault);
  window.addEventListener('ig:ready', skipDigitalPortraitDefault);
})();

// V_WM_PDP_40 | Add c-pill--metric class to labels whose variant value contains 'cm'
(function () {
  function tagMetricPills() {
    if (!document.body.classList.contains('c-variant-redesign-varA') &&
        !document.body.classList.contains('c-variant-redesign-varB')) return;
    document.querySelectorAll('.quantity-breaks-container input[type="radio"]').forEach(function (input) {
      if (input.value.indexOf('cm') !== -1) {
        var label = document.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('c-pill--metric');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(tagMetricPills, 100); });
  window.addEventListener('ig:ready', function () { setTimeout(tagMetricPills, 100); });
})();

// V_WM_PDP_40 | Sync pill label visibility with theme-hidden inputs
(function () {
  function syncPillVisibility() {
    if (!document.body.classList.contains('c-variant-redesign-varA')) return;
    document.querySelectorAll('.quantity-breaks-container label.quantity-break').forEach(function (label) {
      var input = document.getElementById(label.getAttribute('for'));
      if (!input) return;
      // Check label's own inline style (set by theme JS) or input hidden state
      var shouldHide =
        label.style.display === 'none' ||
        input.style.display === 'none' ||
        window.getComputedStyle(input).display === 'none';
      if (shouldHide) {
        label.style.setProperty('display', 'none', 'important');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { setTimeout(syncPillVisibility, 500); });
  window.addEventListener('ig:ready', function () { setTimeout(syncPillVisibility, 500); });
})();

// V_WM_PDP_40 Var B | Build size picker above upload step
(function () {
  function initVarBPills() {
    if (!document.body.classList.contains('c-variant-redesign-varB')) return;

    var container = document.querySelector('.c-varB-size-picker');
    var qbContainer = document.querySelector('.quantity-breaks-container');
    if (!container || !qbContainer) return;
    if (container.querySelector('.c-varB-pills-container')) return; // already initialized

    var pillsWrap = document.createElement('div');
    pillsWrap.className = 'c-varB-pills-container';

    qbContainer.querySelectorAll('input[type="radio"]').forEach(function (input) {
      // Skip hidden/unavailable variants (same logic as Var A CSS)
      if (
        input.classList.contains('non-existent') ||
        input.classList.contains('unavailable') ||
        input.hasAttribute('disabled') ||
        input.value.indexOf('Digital Portrait') !== -1 ||
        (input.value.indexOf('24') !== -1 && input.value.indexOf('32') !== -1)
      ) return;

      var parts = input.value.split(' ');
      var dim = [parts[0], parts[1], parts[2]].join(' ');

      var label = document.createElement('label');
      label.className = 'c-varB-pill' + (input.value.indexOf('cm') !== -1 ? ' c-pill--metric' : '');
      label.setAttribute('for', input.id);

      if (input.value.indexOf('12') !== -1 && input.value.indexOf('16') !== -1) {
        var badge = document.createElement('span');
        badge.className = 'c-best-seller-badge';
        badge.textContent = 'Best Seller';
        label.appendChild(badge);
      }

      label.appendChild(document.createTextNode(dim));
      pillsWrap.appendChild(label);
    });

    container.appendChild(pillsWrap);

    // Clone wood frame info
    var woodFrame = document.querySelector('.c-wood-frame-info');
    if (woodFrame) {
      var woodClone = woodFrame.cloneNode(true);
      woodClone.style.removeProperty('display');
      container.appendChild(woodClone);
    }

    // Sync selected state
    function updateVarBSelection() {
      container.querySelectorAll('.c-varB-pill').forEach(function (pill) {
        var input = document.getElementById(pill.getAttribute('for'));
        if (input) pill.classList.toggle('c-varB-pill--selected', input.checked);
      });
    }

    qbContainer.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', updateVarBSelection);
    });

    updateVarBSelection();
  }

  document.addEventListener('DOMContentLoaded', function () { setTimeout(initVarBPills, 300); });
  window.addEventListener('ig:ready', function () { setTimeout(initVarBPills, 300); });
})();

// Sticky bar for PDP Upload flow
// - Upload / Preview step: shows sticky Create button. Click = scroll to upload section + trigger real Create.
// - Generating step: hidden (progress UI takes focus).
// - Result step: shows sticky Preview + ADD TO CART buttons side-by-side.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var realCreateBtn = document.getElementById('c-pdp-create-btn');
    var realAtcBtn = document.getElementById('c-pdp-atc-btn');
    var realZoomBtn = document.getElementById('c-pdp-zoom-btn');
    var realPreviewBtn = document.getElementById('c-pdp-preview-btn');
    var uploadContainer = document.querySelector('.c-pdp-upload');
    if (!realCreateBtn || !uploadContainer) return;

    // Target section — matches c-pdp-upload-template--{sectionId}__main regardless of product
    var targetSection =
      document.querySelector('[class*="c-pdp-upload-template"][class*="__main"]') ||
      uploadContainer;

    // Build sticky bar
    var stickyBar = document.createElement('div');
    stickyBar.id = 'c-pdp-sticky-bar';
    stickyBar.style.cssText = [
      'position:fixed',
      'bottom:0',
      'left:0',
      'right:0',
      'z-index:9998',
      'background:#fff',
      'padding:12px 16px',
      'box-shadow:0 -4px 20px rgba(0,0,0,0.12)',
      'display:none',
      'gap:10px',
      'align-items:center',
      'justify-content:center'
    ].join(';');

    // Sticky Create button
    var stickyCreate = document.createElement('button');
    stickyCreate.type = 'button';
    stickyCreate.id = 'c-pdp-sticky-create';
    stickyCreate.className = 'button button--primary';
    stickyCreate.textContent = '\uD83C\uDFA8 Create my Portrait';
    stickyCreate.style.cssText = 'width:100%;max-width:560px;margin:0;display:none';

    // Sticky Preview button (secondary)
    var stickyPreview = document.createElement('button');
    stickyPreview.type = 'button';
    stickyPreview.id = 'c-pdp-sticky-preview';
    stickyPreview.className = 'button button--secondary';
    stickyPreview.textContent = 'Preview';
    stickyPreview.style.cssText = 'flex:0 0 auto;margin:0;display:none;white-space:nowrap;min-width:110px';

    // Sticky ATC button (primary)
    var stickyAtc = document.createElement('button');
    stickyAtc.type = 'button';
    stickyAtc.id = 'c-pdp-sticky-atc';
    stickyAtc.className = 'button button--primary';
    stickyAtc.textContent = 'ADD TO CART';
    stickyAtc.style.cssText = 'flex:1 1 auto;margin:0;display:none;max-width:360px';

    stickyBar.appendChild(stickyCreate);
    stickyBar.appendChild(stickyPreview);
    stickyBar.appendChild(stickyAtc);
    document.body.appendChild(stickyBar);

    function getCurrentStep() {
      var resultStep = uploadContainer.querySelector('[data-step="result"]');
      var genStep = uploadContainer.querySelector('[data-step="generating"]');
      if (resultStep && resultStep.style.display !== 'none') return 'result';
      if (genStep && genStep.style.display !== 'none') return 'generating';
      return 'upload';
    }

    function isInView(el) {
      if (!el) return true;
      if (el.style.display === 'none' || el.offsetParent === null) return true;
      var rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function refreshVisibility() {
      var step = getCurrentStep();

      // Hide entirely during generation
      if (step === 'generating') {
        stickyBar.style.display = 'none';
        return;
      }

      if (step === 'result') {
        // Result step — always show Preview + ATC sticky
        // (Real ATC btn in PDP flow is display:none because PDP uses a separate
        // inline ATC below price — so we can't use its visibility as a signal.)
        stickyCreate.style.display = 'none';
        stickyPreview.style.display = (realPreviewBtn || realZoomBtn) ? '' : 'none';
        stickyAtc.style.display = '';
        stickyAtc.disabled = realAtcBtn ? realAtcBtn.disabled : true;
        stickyBar.style.display = 'flex';
      } else {
        // Upload / Preview step — show Create
        stickyCreate.style.display = '';
        stickyPreview.style.display = 'none';
        stickyAtc.style.display = 'none';

        // Only show if real create button is out of view and currently visible in DOM
        var realVisible = realCreateBtn && realCreateBtn.style.display !== 'none';
        if (!realVisible || isInView(realCreateBtn)) {
          stickyBar.style.display = 'none';
        } else {
          stickyBar.style.display = 'flex';
        }
      }
    }

    // Sticky Create click → scroll up to upload section + trigger real create
    // (real button handles validation / error message / generation start)
    stickyCreate.addEventListener('click', function () {
      var scrollTarget = targetSection || uploadContainer;
      if (scrollTarget) {
        var rect = scrollTarget.getBoundingClientRect();
        var top = window.scrollY + rect.top - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      if (realCreateBtn) realCreateBtn.click();
    });

    // Sticky Preview click → open zoom/lightbox
    stickyPreview.addEventListener('click', function () {
      if (realPreviewBtn) realPreviewBtn.click();
      else if (realZoomBtn) realZoomBtn.click();
    });

    // Sticky ATC click → trigger real ATC
    stickyAtc.addEventListener('click', function () {
      if (realAtcBtn && !realAtcBtn.disabled) realAtcBtn.click();
    });

    // Mirror real ATC disabled state
    if (realAtcBtn) {
      new MutationObserver(function () {
        stickyAtc.disabled = realAtcBtn.disabled;
      }).observe(realAtcBtn, { attributes: true, attributeFilter: ['disabled'] });
    }

    // Watch step changes — each step element's inline style flips display on transition
    var stepEls = uploadContainer.querySelectorAll('[data-step]');
    stepEls.forEach(function (el) {
      new MutationObserver(refreshVisibility).observe(el, { attributes: true, attributeFilter: ['style'] });
    });

    // Watch real create/atc display toggles
    if (realCreateBtn) {
      new MutationObserver(refreshVisibility).observe(realCreateBtn, { attributes: true, attributeFilter: ['style'] });
    }
    if (realAtcBtn) {
      new MutationObserver(refreshVisibility).observe(realAtcBtn, { attributes: true, attributeFilter: ['style'] });
    }

    window.addEventListener('scroll', refreshVisibility, { passive: true });
    window.addEventListener('resize', refreshVisibility);

    refreshVisibility();
  });
})();